const TIMER_START = 'TIMER_START';
const TIMER_STOP = 'TIMER_STOP';
const TIMER_TICK = 'TIMER_TICK';

export default {
    TIMER_START,
    TIMER_STOP,
    TIMER_TICK,
};



// WEBPACK FOOTER //
// ./src/redux/modules/timer/constants.ts